import { createSlice } from '@reduxjs/toolkit';
 const poolSlice = createSlice({
    name: 'test',
    initialState: {
      projectName:"",
      projectTypeId:0,
      projectFairId:0,
      poolid:0,
      projectid:0,
      googleCustomAudienceId :0,
      googleResourceName:"",
      value: 0,
      users: [],
      poolFilterJsonSearch: [],
      poolFilterSubSector: [],
      poolFilterCountryList: [],
      poolFilterCompanyTypeList: [],
      poolFilterFairDetailList: [],
      poolFilterFairCustomerTypeList: [],
      poolFilterFuarKatilmaDurumu:null,
      poolFilterProjectIdList:[],
      poolFilterInterviewResultList:[],
      poolFilterCompanyActivityList: [  {id :"manufacturer",name:"Manufacturer",checked:"0"},
      {id :"wholesaler",name:"wholesaler",checked:"0"},
      {id :"importer",name:"importer",checked:"0"},
      {id :"designer",name:"designer",checked:"0"},
      {id :"retail",name:"retail",checked:"0"},
      {id :"other",name:"other",checked:"0"}],
      
    },
    reducers: {

    clearPoolData: (state, action) => {
      console.log("redux update clear :");
      state.projectName="";
      state.projectTypeId=0;
      state.projectFairId=0;
        state.poolid= 0;
        state.projectid= 0;
        state.users=[];
    },
    updatePoolIdAction: (state, action) => {
      console.log("updatePoolIdAction>>updatePoolIdAction:undefined:"+action.payload.poolid);
        state.poolid= action.payload.poolid;
      
    }, updateProjectInfoAction: (state, action) => {
      console.log("updateProjectIdAction:"+action.payload.projectid);
        state.projectName= action.payload.projectName;
        state.projectTypeId= action.payload.projectTypeId;
        state.projectFairId= action.payload.projectFairId;
        state.googleCustomAudienceId =action.payload.googleCustomAudienceId;
        state.googleResourceName=action.payload.googleResourceName;
    },
    updateProjectIdAction: (state, action) => {
      console.log("updateProjectIdAction:"+action.payload.projectid);
        state.projectid= action.payload.projectid;
      
    },
    updatePoolFilterJsonSearch: (state, action) => {
      console.log("updatePoolFilterJsonSearch:"+action.payload.projectid);
        state.poolFilterJsonSearch={...action.payload.poolFilterJsonSearch};
      
    },
      addUserAction: (state, action) => {
  
        var kontrol=state.users.filter(x =>{return x.id == action.payload.id}) 
        if(kontrol.length==0)
        return { // returning a copy of orignal state 
            ...state, //spreading the original state
            users: [{id: action.payload.id}, ...state.users] // new todos array
           }
           else
           {
            return state
           }
      }, deleteUserAction: (state, action) => {
        var kontrol=  state.users.filter(x => x.id != action.payload.id)
            console.log("heee:"+JSON.stringify(kontrol) );
        return { // returning a copy of orignal state 
            ...state, //spreading the original state
            users: [ ...state.users.filter(x => x.id != action.payload.id) ] // new todos array
           }
           
      },

    // havuz için
      addPoolFilterSubSector: (state, action) => {
        console.log("adas addPoolFilterSubSector:"+action.payload.id);
        console.log("heee addPoolFilterSubSector:"+JSON.stringify( state.poolFilterSubSector) );
        var kontrol= state.poolFilterSubSector.filter(x =>{return x.id === action.payload.id});
        if(kontrol.length===0)
        return { // returning a copy of orignal state 
            ...state, //spreading the original state
            poolFilterSubSector: [{id: action.payload.id,name:action.payload.name}, ...state.poolFilterSubSector] // new todos array
           }
           else
           {
            return state
           }
      },removePoolFilterSubSector : (state, action) => {
        var kontrol=  state.poolFilterSubSector.filter(x => x.id != action.payload.id)
            console.log("heee:"+JSON.stringify(kontrol) );
        return { // returning a copy of orignal state 
            ...state, //spreading the original state
            poolFilterSubSector: [ ...state.poolFilterSubSector.filter(x => x.id !== action.payload.id) ] // new todos array
           }
           
      },
      // company liste
      addPoolFilterCountryList: (state, action) => {
        console.log("adas addPoolFilterSubSector:"+action.payload.id);
        console.log("heee addPoolFilterSubSector:"+JSON.stringify( state.poolFilterCountryList) );
        var kontrol= state.poolFilterCountryList.filter(x =>{return x.id === action.payload.id});
        if(kontrol.length===0)
        return { // returning a copy of orignal state 
            ...state, //spreading the original state
            poolFilterCountryList: [{id: action.payload.id,name:action.payload.name}, ...state.poolFilterCountryList] // new todos array
           }
           else
           {
            return state
           }
      },removePoolFilterCountryList : (state, action) => {
        var kontrol=  state.poolFilterCountryList.filter(x => x.id != action.payload.id)
            console.log("heee:"+JSON.stringify(kontrol) );
        return { // returning a copy of orignal state 
            ...state, //spreading the original state
            poolFilterCountryList: [ ...state.poolFilterCountryList.filter(x => x.id !== action.payload.id) ] // new todos array
           }
           
      },
     
            // company activity liste
            addPoolFilterCompanyActivityList: (state, action) => {
              var kontrol= state.poolFilterCompanyActivityList.filter(x =>{return x.id === action.payload.id});
              console.log("addPoolFilterCompanyTypeList:"+JSON.stringify(kontrol) );
              if(kontrol.length===0)
              return { // returning a copy of orignal state 
                  ...state, //spreading the original state
                  poolFilterCompanyActivityList: [{id: action.payload.id,name:action.payload.name}, ...state.poolFilterCompanyActivityList] // new todos array
                 }
                 else
                 {
                  return state
                 }
            },removePoolFilterCompanyActivityList : (state, action) => {
              var kontrol=  state.poolFilterCompanyActivityList.filter(x => x.id != action.payload.id)
                  console.log("heee:"+JSON.stringify(kontrol) );
              return { // returning a copy of orignal state 
                  ...state, //spreading the original state
                  poolFilterCompanyActivityList: [ ...state.poolFilterCompanyActivityList.filter(x => x.id !== action.payload.id) ] // new todos array
                 }
                 
            },
                    // company activity
             updatePoolFilterCompanyActivityList : (state, action) => {
              var foundIndex = state.poolFilterCompanyActivityList.findIndex(x => x.id === action.payload.id);
              state.poolFilterCompanyActivityList[foundIndex].checked=action.payload.checked;
            }     ,
                // fuar detail liste --------------------------------------------------------------
            addPoolFilterFairDetailList: (state, action) => {
              var kontrol= state.poolFilterFairDetailList.filter(x =>{return x.id === action.payload.id});
              if(kontrol.length===0)
              return { // returning a copy of orignal state 
                  ...state, //spreading the original state
                  poolFilterFairDetailList: [{id: action.payload.id,name:action.payload.name}, ...state.poolFilterFairDetailList] // new todos array
                 }
                 else
                 {
                  return state
                 }
            },removePoolFilterFairDetailList : (state, action) => {
              var kontrol=  state.poolFilterFairDetailList.filter(x => x.id != action.payload.id)
              return { // returning a copy of orignal state 
                  ...state, //spreading the original state
                  poolFilterFairDetailList: [ ...state.poolFilterFairDetailList.filter(x => x.id !== action.payload.id) ] // new todos array
                 }
            },   
         
             // fuar müşteri tipi  liste --------------------------------------------------------------------------
            addPoolFilterProjectIdList: (state, action) => {
              var kontrol= state.poolFilterProjectIdList.filter(x =>{return x.id === action.payload.id});
              if(kontrol.length===0)
              return { // returning a copy of orignal state 
                  ...state, //spreading the original state
                  poolFilterProjectIdList: [{id: action.payload.id,name:action.payload.name}, ...state.poolFilterProjectIdList] // new todos array
                 }
                 else
                 {
                  return state
                 }
            },removePoolFilterProjectIdList: (state, action) => {
              var kontrol=  state.poolFilterProjectIdList.filter(x => x.id != action.payload.id)
              return { // returning a copy of orignal state 
                  ...state, //spreading the original state
                  poolFilterProjectIdList: [ ...state.poolFilterProjectIdList.filter(x => x.id !== action.payload.id) ] // new todos array
                 }
            },    
            // fuar müşteri tipi  liste --------------------------------------------------------------------------
        addPoolFilterFairCustomerTypeList: (state, action) => {
          var kontrol= state.poolFilterFairCustomerTypeList.filter(x =>{return x.id === action.payload.id});
          if(kontrol.length===0)
          return { // returning a copy of orignal state 
              ...state, //spreading the original state
              poolFilterFairCustomerTypeList: [{id: action.payload.id,name:action.payload.name}, ...state.poolFilterFairCustomerTypeList] // new todos array
             }
             else
             {
              return state
             }
        },removePoolFilterFairCustomerTypeList : (state, action) => {
          var kontrol=  state.poolFilterFairCustomerTypeList.filter(x => x.id != action.payload.id)
          return { // returning a copy of orignal state 
              ...state, //spreading the original state
              poolFilterFairCustomerTypeList: [ ...state.poolFilterFairCustomerTypeList.filter(x => x.id !== action.payload.id) ] // new todos array
             }
        },             
         // fuar katılma durumu
         updatePoolFilterFuarKatilmaDurumu: (state, action) => {
      console.log("reddd:"+action.payload.durum)
      if(action.payload.durum>0)
            state.poolFilterFuarKatilmaDurumu= action.payload.durum;
            else
            state.poolFilterFuarKatilmaDurumu= null;
        },       
           // interview result id --------------------------------------------------------------------------
        addPoolFilterPoolFilterInterviewResultList: (state, action) => {
          var kontrol= state.poolFilterInterviewResultList.filter(x =>{return x.id === action.payload.id});
          if(kontrol.length===0)
          return { // returning a copy of orignal state 
              ...state, //spreading the original state
              poolFilterInterviewResultList: [{id: action.payload.id,name:action.payload.name}, ...state.poolFilterInterviewResultList] // new todos array
             }
             else
             {
              return state
             }
        },removePoolFilterInterviewResultList : (state, action) => {
          var kontrol=  state.poolFilterInterviewResultList.filter(x => x.id != action.payload.id)
          return { // returning a copy of orignal state 
              ...state, //spreading the original state
              poolFilterInterviewResultList: [ ...state.poolFilterInterviewResultList.filter(x => x.id !== action.payload.id) ] // new todos array
             }
        }, 


          }
  });
  
  export const {updatePoolFilterJsonSearch, addPoolFilterPoolFilterInterviewResultList,removePoolFilterInterviewResultList,  addPoolFilterProjectIdList,removePoolFilterProjectIdList,updatePoolFilterFuarKatilmaDurumu,addPoolFilterFairCustomerTypeList,removePoolFilterFairCustomerTypeList,removePoolFilterFairDetailList,addPoolFilterFairDetailList,updatePoolFilterCompanyActivityList,addPoolFilterCompanyActivityList,removePoolFilterCompanyActivityList,
    addPoolFilterCountryList,removePoolFilterCountryList,addUserAction,deleteUserAction,updatePoolIdAction,updateProjectIdAction,clearPoolData,updateProjectInfoAction,addPoolFilterSubSector,removePoolFilterSubSector } = poolSlice.actions;
  export const selectUsers = state => state.reducerPool.users;
  export const poolFilterSubSector = state => state.reducerPool.poolFilterSubSector;
 
  export const poolFilterCompanyActivityList = state => state.reducerPool.poolFilterCompanyActivityList;
  export const poolFilterFairDetailList = state => state.reducerPool.poolFilterFairDetailList;
  export const poolFilterCountryList = state => state.reducerPool.poolFilterCountryList;
  export const poolFilterFairCustomerTypeList = state => state.reducerPool.poolFilterFairCustomerTypeList;
  export const poolFilterFuarKatilmaDurumu = state => state.reducerPool.poolFilterFuarKatilmaDurumu;
  export const poolFilterProjectIdList = state => state.reducerPool.poolFilterProjectIdList;
  export const poolFilterInterviewResultList = state => state.reducerPool.poolFilterInterviewResultList;
  export const poolFilterJsonSearch = state => state.reducerPool.poolFilterJsonSearch;

  export const selectPoolId = state => state.reducerPool.poolid;
  export const selectProjectId = state => state.reducerPool.projectid;
  export const selectProjectName = state => state.reducerPool.projectName;
  export const selectProjectTypeId = state => state.reducerPool.projectTypeId;
  export const selectProjectFairId = state => state.reducerPool.projectFairId;
 export default poolSlice.reducer;